import { motion } from "framer-motion";
import { APP_SCREENS } from "@/lib/leadzi";

export const HeroPhoneMobile = () => {
  return (
    <section className="bg-white px-4 pb-16 pt-4 lg:hidden">
      <motion.div
        initial={{ opacity: 0, scale: 0.94, y: 30 }}
        whileInView={{ opacity: 1, scale: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="relative mx-auto w-full max-w-[16rem]"
      >
        <div className="absolute -inset-6 -z-10 rounded-[3rem] bg-brand/20 blur-3xl" />
        <div className="relative overflow-hidden rounded-[2.5rem] border-[9px] border-ink bg-ink shadow-[0_30px_60px_-20px_rgba(13,15,18,0.5)]">
          <div className="absolute left-1/2 top-0 z-10 h-5 w-28 -translate-x-1/2 rounded-b-2xl bg-ink" />
          <img src={APP_SCREENS.newOpportunity} alt="Application Leadzi CHR — nouvelle opportunité" className="block w-full" />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.25 }}
          className="absolute -right-3 top-12 w-48 rounded-2xl border border-black/5 bg-white p-3.5 shadow-2xl"
        >
          <div className="mb-1 text-[10px] font-bold uppercase tracking-wider text-brand">Nouvelle opportunité</div>
          <div className="text-sm font-bold text-ink">Restaurant Le Patio</div>
          <div className="mt-1 text-xs text-ink/50">Besoin · Solution de caisse</div>
          <div className="mt-2.5 inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-2.5 py-1 text-[10px] font-bold text-emerald-600">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" /> Opportunité envoyée
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};
